import { render, staticRenderFns } from "./JSONView.vue?vue&type=template&id=5891108a"
import script from "./JSONView.vue?vue&type=script&lang=js"
export * from "./JSONView.vue?vue&type=script&lang=js"
import style0 from "./JSONView.vue?vue&type=style&index=0&id=5891108a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports